import { Container, IconButton } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Navbar.module.scss";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Drawer } from "antd";
import useDeviceCheck from "Hooks/useDeviceCheck";
import useExploreInfo from "Hooks/useExploreInfo";
import { ImageType } from "Explore/Config/ImageType";
import { _nav } from "Explore/Routes/navbarContent";
import DropdownNav from "./Components/Dropdown/Dropdown";
import { useSelector } from "react-redux";
import logo from "Explore/Assets/logo.png";
import classNames from "classnames";
import FavoriteItemNav from "./Components/FavoriteItemNav";
import CompareItemNav from "./Components/CompareItemNav";

const Navbar = () => {
  const { isTablet } = useDeviceCheck();
  const navigate = useNavigate();
  const { entity_type } = useExploreInfo();
  const { landscapeBackground } = useSelector((state) => state.commonState);
  const [current, setCurrent] = useState(-1);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const ref = useRef(null);


  const onClickMenuItem = (item) => {
    navigate(`/explore${item.to}`);
    setCurrent(item.key);
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    // Match entity_type against top-level or child nav items
    let matchedKey = "";
    for (const item of _nav) {
      if (item.key === entity_type || item.to?.includes(entity_type)) {
        matchedKey = item.key;
        break;
      }
      if (item.children) {
        const child = item.children.find(
          (c) => c.key === entity_type || c.to?.includes(entity_type)
        );
        if (child) {
          matchedKey = child.key;
          break;
        }
      }
    }
    setCurrent(matchedKey);
  }, [entity_type]);

  useEffect(() => {
    if (isTablet) {
      const handleScroll = () => {
        const currentScrollTop = window.scrollY;

        if (currentScrollTop >= lastScrollTop && currentScrollTop > 60) {
          ref.current.classList.add(styles["hide"]);
        } else {
          ref.current.classList.remove(styles["hide"]);
        }

        setLastScrollTop(currentScrollTop);
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [lastScrollTop]);

  const renderLogo = () => {
    return (
      <img
        src={logo}
        alt="logo"
        className={styles["logo"]}
        onClick={() => {
          navigate(`/explore`);
          setCurrent("");
          window.scrollTo(0, 0);
        }}
      />
    );
  };

  const isChildActive = (item) => {
    if (!item.children) return false;
    return item.children.some((child) => child.key === current);
  };

  const renderMenuItem = () => {
    return (
      <>
        {_nav.map((item, index) => {
          if (item.children) {
            const active = isChildActive(item);
            return (
              <div
                key={index}
                className={classNames(
                  styles["item_menu"],
                  styles["item_menu--parent"],
                  { [styles["selected"]]: active }
                )}
              >
                {active ? item.svg_fill : item.svg}
                <p>{item.label}</p>
                <KeyboardArrowDownIcon
                  className={styles["item_menu--arrow"]}
                  style={{ fontSize: 16 }}
                />
                <div className={styles["item_menu__dropdown"]}>
                  {item.children.map((child) => (
                    <div
                      key={child.key}
                      className={classNames(styles["item_menu__dropdown-item"], {
                        [styles["selected"]]: current === child.key,
                      })}
                      onClick={() => onClickMenuItem(child)}
                    >
                      {child.svg}
                      <span>{child.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          }

          return (
            <div
              key={index}
              className={
                current == item.key
                  ? `${styles["item_menu"]} ${styles["selected"]}`
                  : styles["item_menu"]
              }
              onClick={() => onClickMenuItem(item)}
            >
              {current == item.key
                ? item.svg_fill
                : item.svg}
              <p>{item.label}</p>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <>
      <div
        ref={ref}
        className={classNames(styles["navbar-landscape"])}
      >
        <Container maxWidth="lg" className={styles["container"]}>
          <div className={styles["left"]}>
            {isTablet && (
              <IconButton onClick={() => setOpenDrawer(true)}>
                <MenuIcon />
              </IconButton>
            )}
            {renderLogo()}
            {!isTablet && renderMenuItem()}
          </div>
          <div className={styles["right"]}>
            <CompareItemNav whiteTheme={false} />
            <FavoriteItemNav whiteTheme={false} />
            <DropdownNav landscape={landscapeBackground} />
          </div>
        </Container>
      </div>

      <Drawer
        title={<div className={styles["logo-container"]}>{renderLogo()}</div>}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        placement="left"
        width="200px"
        classNames={{
          header: styles["drawer__header"],
          body: styles["drawer__body"],
        }}
        zIndex={1002}
      >
        <div className={styles["drawer"]}>{renderMenuItem()}</div>
      </Drawer>
    </>
  );
};

export default Navbar;
